export const hybridRoutes = [
  {
    path: '/verificar-link',
    name: 'CheckLink',
    meta: {
      hybridRoute: true
    },
    component: () => import(/* webpackChunkName: 'check-link-page' */ 'views/CheckLinkPage')
  },
  {
    path: '/link-expirado',
    name: 'ExpiredLink',
    meta: {
      hybridRoute: true
    },
    component: () => import(/* webpackChunkName: 'expired-link-page' */ 'views/ExpiredLinkPage')
  },
  {
    path: '/sap-concur-integration',
    name: 'SAPConcurIntegration',
    meta: {
      hybridRoute: true
    },
    component: () => import(/* webpackChunkName: 'sap-concur-integration-page' */ 'views/SAPConcurIntegrationPage')
  },
  {
    path: '/sistema-indisponivel',
    name: 'UnavailableSystem',
    meta: {
      hybridRoute: true
    },
    component: () => import(/* webpackChunkName: 'unavailable-system-page' */ 'views/UnavailableSystemPage')
  }
]
